import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63c60335"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-fashion-tile" }
const _hoisted_2 = {
  ref: "tileWrapper",
  class: "frisbuy-fashion-tile__wrapper"
}
const _hoisted_3 = {
  key: 0,
  ref: "tileTitle",
  class: "frisbuy-fashion-tile__title"
}
const _hoisted_4 = {
  key: 1,
  ref: "tileSubtitle",
  class: "frisbuy-fashion-tile__subtitle"
}
const _hoisted_5 = { class: "frisbuy-fashion-tile__main-item" }
const _hoisted_6 = { class: "products-scoll-block" }
const _hoisted_7 = { class: "frisbuy-fashion-tile__kit-products" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonArrow = _resolveComponent("ButtonArrow")!
  const _component_LikeButton = _resolveComponent("LikeButton")!
  const _component_ProductItem = _resolveComponent("ProductItem")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_ctx.titleMode !== 'hidden')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.titleMode === 'default')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Готовые комплекты ")
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.titleMode === 'postsCount')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Посмотрите " + _toDisplayString(_ctx.productsList.length) + " " + _toDisplayString(_ctx.getPluralizationForProductsTitle(_ctx.productsList.length)) + " из образа ", 1)
                ], 64))
              : _createCommentVNode("", true)
          ], 512))
        : _createCommentVNode("", true),
      (_ctx.titleMode == 'default')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Наводите на товар и переходите в карточку товара ", 512))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "frisbuy-fashion-tile__kit",
        ref: "tileKit",
        style: _normalizeStyle({ height: _ctx.fashionTileKitHeight })
      }, [
        _withDirectives(_createVNode(_component_ButtonArrow, {
          onClick: _cache[0] || (_cache[0] = () => _ctx.makeEventToChangePost(-1)),
          direction: 'left'
        }, null, 512), [
          [_vShow, _ctx.hasPrevPost]
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.productsList.length)
            ? (_openBlock(), _createBlock(_component_LikeButton, {
                key: 0,
                isLiked: _ctx.isFullFavoriteLook,
                onClick: _cache[1] || (_cache[1] = () => _ctx.addProductToFavoriteList(_ctx.productsList, false))
              }, null, 8, ["isLiked"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "imageArea", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsList, (product) => {
              return (_openBlock(), _createBlock(_component_ProductItem, {
                key: product.id,
                product: product,
                linkTarget: 
                Boolean(_ctx.popupSettings.targetBlankLink) ? '_blank' : '_self'
              ,
                popupText: _ctx.popupText,
                isLiked: 
                Boolean(
                  _ctx.favoriteVendorList.find((el) =>
                    _ctx.isEqual(el, {
                      article: product.sku?.vendorCode,
                      offerId: product.sku?.offerId,
                      groupId: product.sku?.groupId,
                    })
                  )
                )
              ,
                onClickProduct: (product) => _ctx.sendProductAnalytics(product),
                onLike: () => _ctx.addProductToFavoriteList([product])
              }, null, 8, ["product", "linkTarget", "popupText", "isLiked", "onClickProduct", "onLike"]))
            }), 128))
          ])
        ]),
        _withDirectives(_createVNode(_component_ButtonArrow, {
          onClick: _cache[2] || (_cache[2] = () => _ctx.makeEventToChangePost(1)),
          direction: 'right'
        }, null, 512), [
          [_vShow, _ctx.hasNextPost]
        ])
      ], 4)
    ])), [
      [_directive_touch, (direction) => _ctx.changePostBySwipe(direction), "swipe"]
    ])
  ]))
}